<template>
	<BaseModal @close="$emit('close')">
		<template #title>Guest reporter role</template>

		<img src="../img/bug-reporter.svg" width="312" height="108" class="mb-24" />

		<p class="mb-8">
			As a guest reporter in this workspace, you can report bugs privately and access your sessions.
		</p>
		<p>
			To view all other sessions and access more workspace settings, please contact an admin to change your role.
		</p>

		<template #footer>
			<BaseButton class="button-blue" @click="$emit('close')">Got it</BaseButton>
		</template>
	</BaseModal>
</template>
<script>
export default {
	name: 'ModalBugReporterInfo',
	emits: ['close'],
}
</script>
